export default __webpack_public_path__ + "static/media/psql.b0e8eea5.png";